import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const TaskGroupIcon = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M6.5 4a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1h1c.827 0 1.5.673 1.5 1.5v15c0 .827-.673 1.5-1.5 1.5h-14c-.827 0-1.5-.673-1.5-1.5v-15C4 4.673 4.673 4 5.5 4h1zM9 16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1zm8.5 1a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6zM9 17H8v1h1v-1zm0-5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1zm8.5 1a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6zM9 13H8v1h1v-1zm0-5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1zm8.5 1a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6zM9 9H8v1h1V9zm3.499-8c1.224 0 2.246.885 2.459 2.049.218.041.489.116.764.254.816.408 1.268 1.178 1.276 2.17l.001.027a.5.5 0 0 1-.5.5H8.5a.5.5 0 0 1-.5-.5c0-1.005.453-1.786 1.276-2.197.275-.138.547-.213.764-.254A2.504 2.504 0 0 1 12.499 1zm.001 1c-.827 0-1.5.673-1.5 1.5a.5.5 0 0 1-.5.5c-.001 0-.413.007-.802.21A1.208 1.208 0 0 0 9.06 5h6.88a1.21 1.21 0 0 0-.638-.79c-.389-.203-.8-.21-.805-.21A.498.498 0 0 1 14 3.5c0-.827-.673-1.5-1.5-1.5zm0 1a.498.498 0 0 1 .5.5.5.5 0 1 1-.5-.5z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      }}
    />
  </SvgIcon>
);

export default TaskGroupIcon;
